import React from "react";
import CategoryTag from "./CategoryTag";
import MinMaxTag from "./MinMaxTag";

const Components = {
  categoryTag: CategoryTag,
  minMaxTag: MinMaxTag,
};

const SliderItemTag = ({ component, props }) => {
  return React.createElement(Components[component], props);
};

export default SliderItemTag;
